const GAME_CONFIG = Object.freeze({
  key: 'seashroud',
  name: 'Sea Shroud',
  wordmarkMain: 'Sea',
  wordmarkAccent: 'Shroud',
  badge: 'S',
  accent: '#56616b',
  accentDark: '#3f4851',
  timezone: process.env.REACT_APP_TIMEZONE || 'America/Phoenix',
  gridSize: 8,
});

export default GAME_CONFIG;

